<template>
  <div>{{ status }}</div>
</template>
<script>
import Vue from "vue";

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();

export default {
  components: {},
  data() {
    return {
      status: "init",
      checkInterval: 300
    };
  },
  methods: {
    loadHtmlFromUrl() {
      var url = window.location.href;
      var arr = url.split("/");

      this.$http.get(arr[0] + "//" + arr[2]).then(
        response => {
          let html = response.body;

          let withQuotes = false;
          let tagStart = html.indexOf("<meta property=build:number");
          if (tagStart === -1) {
            withQuotes = true;
            tagStart = html.indexOf('<meta property="build:number');
          }

          let tagEnd = html.indexOf(">", tagStart);

          let contentStart = html.indexOf("content=", tagStart);

          if (withQuotes === false) {
            this.checkBuildNumber(html.substring(contentStart + 8, tagEnd));

            return;
          }

          this.checkBuildNumber(html.substring(contentStart + 9, tagEnd - 1));
        },
        response => {}
      );
    },
    checkBuildNumber(buildNumberFromHttp) {
      let buildNumberFromDom = document.querySelector(
        'meta[property="build:number"]'
      ).content;

      if (buildNumberFromDom !== buildNumberFromHttp) {
        this.notifyVue(
          "Een nieuwe versie van de software is gedetecteerd. Vernieuw de pagina in de browser om de nieuwste versie van de software te laden.<br/><br/>Wanneer je deze melding blijft zien, <a href='https://www.google.nl/search?q=browser+cache+legen+" +
            this.getBrowserName() +
            "' target='_blank' style='color: #fff; text-decoration: underline;'>leeg dan de cache van je browser</a>.",
          "refresh",
          "warning",
          this.checkInterval * 1000
        );
      }
    },
    getBrowserName() {
      var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browserName = navigator.appName;
      var fullVersion = "" + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset, verOffset, ix;

      // In Opera, the true version is after "OPR" or after "Version"
      if ((verOffset = nAgt.indexOf("OPR")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 4);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In MS Edge, the true version is after "Edg" in userAgent
      else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
        browserName = "Microsoft Edge";
        fullVersion = nAgt.substring(verOffset + 4);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In Chrome, the true version is after "Chrome"
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version"
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Firefox, the true version is after "Firefox"
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent
      else if (
        (nameOffset = nAgt.lastIndexOf(" ") + 1) <
        (verOffset = nAgt.lastIndexOf("/"))
      ) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

      majorVersion = parseInt("" + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = "" + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }

      // console.log(
      //   "" +
      //     "Browser name  = " +
      //     browserName +
      //     "<br>" +
      //     "Full version  = " +
      //     fullVersion +
      //     "<br>" +
      //     "Major version = " +
      //     majorVersion +
      //     "<br>" +
      //     "navigator.appName = " +
      //     navigator.appName +
      //     "<br>" +
      //     "navigator.userAgent = " +
      //     navigator.userAgent +
      //     "<br>"
      // );

      return browserName;
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  created() {
    setTimeout(this.loadHtmlFromUrl, 1000);
    setInterval(this.loadHtmlFromUrl, this.checkInterval * 1000);
  }
};
</script>
<style lang="scss" scoped>
div {
  display: none;
}
</style>
